import {
  FETCH_NEGATIVE_ITEM,
  RESET_NEGATIVE_ITEM,
} from "../../constants/action.constants";

const initialState = {
  data: {},
};

const negativeItemViewReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_NEGATIVE_ITEM:
      return { data: action.payload };
    case RESET_NEGATIVE_ITEM:
      return initialState;
    default:
      return state;
  }
};

export default negativeItemViewReducer;
